let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let FormUtils = require("../../utils/FormUtils");
let FormMixin = require("react-loose-forms");

module.exports = dd.createClass({
	mixins: [FormMixin],
	getInitialValuesSourceVersion(props){
		return props.sid;
	},
	getInitialValues(props){
		return {speaker: props.sid};
	},
	buildSchema(){
		let {Displaylists, sids_to_choose} = this.props;
		let options = FormUtils.getSpeakerNamesBySid(Displaylists, false);

		if(_.isArray(sids_to_choose)){
			var new_opts = {};
			_.each(sids_to_choose, function(sid){
				new_opts[sid] = _.has(options, sid)
					? options[sid]
					: "speaker:" + sid;//this is very unlikely
			});
			options = new_opts;
		}
		return {
			speaker: {
				type: "select",
				options: options,
				validate(v){
					let sid = esUtils.toInt(v);
					return _.has(options, sid) ? true : "Please select a speaker";
				}
			}
		};
	},
	onFormChanged(field_path, new_value){
		if(field_path === "speaker"){
			let sid = esUtils.toInt(new_value);
			if(sid > 0){
				this.props.onSidChanged(sid);
			}
		}
	},
	__startValidation(){
		if(this.state.submit_attempts == 0){
			this.Form_onSubmit();//so that validation will kick in
		}
	},
	componentDidUpdate(){
		this.__startValidation();
	},
	componentDidMount(){
		this.__startValidation();
	},
	render(){
		let fields = this.Form_buildSchema();
		let errors = this.state.errors || {};

		return dd.form({onSubmit: this.Form_onSubmit, role: "form"},
			dd.div({className: "form-group"},
				dd.label({className: "control-label col-sm-2 text-right"}, "For Speaker "),
				dd.div({className: "col-sm-10", style: {display: "inline-block", width: 260, margin: "0 0 20px 10px"}},
					this.Form_buildInput(fields.speaker),
					errors["speaker"] ? dd.span({className: "help-block"}, errors["speaker"]) : null
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/account_settings/SpeakerForm.js